export default {
  password: {
    requirements: {
      id: 'register.password.requirements',
      defaultMessage: 'Password must be at least 8 characters long and must contain:',
    },
  },
};
